import React from "react";

export const Container = ({ children }) => {
  return (
    <div className="flex flex-col sm:flex-row w-full sm:min-h-[calc(100vh-65px-75px)] relative">
      {children}
    </div>
  );
};

export default Container;
